import { useEffect, type ReactNode } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchEnvs } from '@/store/slices/envsSlice';
import PageSpinner from '@/components/PageSpinner';

/**
 * 원본: UserDashboard.componentDidMount → envsActions.envs.get()
 * 앱 초기화 시 환경 설정 + 현재 사용자 정보를 로드한다.
 */

interface AuthInitProps {
  children: ReactNode;
}

export function AuthInit({ children }: AuthInitProps) {
  const dispatch = useAppDispatch();
  const env = useAppSelector((s) => s.envs.env);
  const loading = useAppSelector((s) => s.envs.loading);

  useEffect(() => {
    dispatch(fetchEnvs());
  }, [dispatch]);

  // 초기 로딩 중 (env가 아직 없는 동안)
  if (loading && !env) {
    return <PageSpinner />;
  }

  return <>{children}</>;
}
